/* HEMĒRA — shared theme behaviour
   Loaded with `defer` from theme.liquid. All selectors are global/single-use,
   so each section can render its markup and this script wires them up. */
(function(){
  'use strict';

  var REDUCE = matchMedia('(prefers-reduced-motion:reduce)').matches;
  // Only opt into hide-then-reveal animation when motion is allowed AND JS is running.
  // If this line never runs (JS fails) or motion is reduced, all text stays visible.
  if (!REDUCE) document.documentElement.classList.add('anim');

  /* ===== LIGHT-BIRTH INTRO SEQUENCE (hero) ===== */
  var cinema = document.getElementById('top');
  var follow = document.getElementById('follow');
  if (cinema && follow) {
    if (REDUCE) {
      cinema.classList.add('lit');
    } else {
      requestAnimationFrame(function(){ cinema.classList.add('draw'); });
      setTimeout(function(){ cinema.classList.add('travel'); }, 1500);
      setTimeout(function(){ cinema.classList.add('bloom'); cinema.classList.add('lit'); }, 2700);
      setTimeout(function(){ follow.style.opacity = 1; }, 4000);
      var killed = false;
      addEventListener('scroll', function(){
        if (!cinema.classList.contains('lit')) { follow.style.opacity = 0; return; }
        if (!killed && scrollY > 0) { follow.style.transition = 'none'; killed = true; }
        var h = cinema.offsetHeight;
        var p = Math.min(1, scrollY / (h * 0.95));
        follow.style.opacity = Math.max(0, 1 - p * 1.05);
        follow.style.transform = 'translateY(calc(-50% + ' + (p * h * 0.55) + 'px))';
      }, { passive:true });
    }
  }

  /* ===== custom cursor ===== */
  var cursor = document.getElementById('cursor');
  if (cursor && matchMedia('(hover:hover)').matches) {
    addEventListener('mousemove', function(e){ cursor.style.left = e.clientX+'px'; cursor.style.top = e.clientY+'px'; });
    document.querySelectorAll('a,button,input').forEach(function(el){
      el.addEventListener('mouseenter', function(){ cursor.classList.add('big'); });
      el.addEventListener('mouseleave', function(){ cursor.classList.remove('big'); });
    });
  }

  /* ===== scroll reveals ===== */
  var io = new IntersectionObserver(function(es){
    es.forEach(function(e){ if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
  }, { threshold:0, rootMargin:'0px 0px -8% 0px' });
  document.querySelectorAll('.reveal').forEach(function(el){ io.observe(el); });

  /* ===== word-by-word reveal (feeling lines) ===== */
  document.querySelectorAll('.wordline').forEach(function(line){
    var frag = line.cloneNode(true);
    line.innerHTML = '';
    frag.childNodes.forEach(function(node){
      if (node.nodeType === 3) {
        node.textContent.split(/(\s+)/).forEach(function(w){
          if (w.trim() === '') { line.appendChild(document.createTextNode(w)); }
          else { var s = document.createElement('span'); s.className = 'word'; s.textContent = w; line.appendChild(s); }
        });
      } else { if (node.classList) node.classList.add('word'); line.appendChild(node); }
    });
  });
  var wio = new IntersectionObserver(function(es){
    es.forEach(function(e){
      if (e.isIntersecting) {
        Array.prototype.slice.call(e.target.querySelectorAll('.word')).forEach(function(w,i){
          setTimeout(function(){ w.classList.add('in'); }, i*70);
        });
        wio.unobserve(e.target);
      }
    });
  }, { threshold:.25 });
  document.querySelectorAll('.wordline').forEach(function(l){ wio.observe(l); });

  /* ===== safety net: nothing may stay invisible =====
     If an observer ever fails to fire (theme quirks, layout, etc.), reveal
     everything after a short delay so all copy is guaranteed visible. */
  setTimeout(function(){
    document.querySelectorAll('.reveal:not(.in)').forEach(function(el){ el.classList.add('in'); });
    document.querySelectorAll('.word:not(.in)').forEach(function(w){ w.classList.add('in'); });
  }, 3000);

  /* ===== light: drifting sun + background colour per section =====
     sx/sy are viewport units: the sun moves with transform (see theme.liquid), so it never shifts layout. */
  var LIGHT = {
    dawn:{sx:'72vw',sy:'2vh',bg:'#8f1414',bg2:'#a81f1f'},
    morning:{sx:'58vw',sy:'-8vh',bg:'#a81d1d',bg2:'#bd2525'},
    noon:{sx:'50vw',sy:'-16vh',bg:'#b52424',bg2:'#c93030'},
    afternoon:{sx:'34vw',sy:'0vh',bg:'#a81d1d',bg2:'#bd2727'},
    dusk:{sx:'22vw',sy:'12vh',bg:'#7d1414',bg2:'#9c1d1d'}
  };
  var root = document.documentElement;
  function setLight(name){
    var L = LIGHT[name] || LIGHT.noon;
    root.style.setProperty('--sx', L.sx); root.style.setProperty('--sy', L.sy);
    root.style.setProperty('--bg', L.bg); root.style.setProperty('--bg2', L.bg2);
  }
  var lio = new IntersectionObserver(function(es){
    es.forEach(function(e){ if (e.isIntersecting && e.intersectionRatio > .5) setLight(e.target.dataset.light); });
  }, { threshold:[.5] });
  document.querySelectorAll('[data-light]').forEach(function(el){ lio.observe(el); });
  setLight('dawn');

  /* ===== ribbon: a cream thread drawn down the page ===== */
  var ribbon = document.getElementById('ribbon');
  var rp = document.getElementById('ribbonPath');
  if (ribbon && rp) {
    var heroEl = document.getElementById('top');
    var drawRibbon = function(){
      var w = innerWidth, vh = innerHeight, H = document.body.scrollHeight, y = scrollY;
      var pts = [[0,.36],[.16,.36],[.32,.6],[.5,.40],[.66,.66],[.82,.32],[1,.5]];
      var d = '';
      pts.forEach(function(p,i){
        var py = p[0]*H - y, px = p[1]*w;
        d += i===0 ? ('M '+px+' '+py) : (' S '+px+' '+(py-vh*0.12)+' '+px+' '+py);
      });
      rp.setAttribute('d', d);
      ribbon.setAttribute('viewBox', '0 0 '+w+' '+vh);
      ribbon.style.height = vh+'px';
      // keep the ribbon off the opening video; fade it in as the hero scrolls away
      var hH = heroEl ? heroEl.offsetHeight : vh;
      ribbon.style.opacity = Math.min(1, Math.max(0, y/(hH*0.7)));
    };
    addEventListener('resize', drawRibbon);
    addEventListener('scroll', drawRibbon, { passive:true });
    drawRibbon();
  }

  /* ===== six keys interactive ===== */
  var knav = document.getElementById('knav');
  var kvis = document.getElementById('kvis');
  if (knav && kvis) {
    var KEYS = Array.prototype.slice.call(knav.querySelectorAll('button')).map(function(b){
      return { t: b.getAttribute('data-title') || '', d: b.getAttribute('data-desc') || '', svg: b.getAttribute('data-svg') || '' };
    });
    var vc = document.getElementById('vc'), kicon = document.getElementById('kicon'),
        ktitle = document.getElementById('ktitle'), kdesc = document.getElementById('kdesc');
    var showKey = function(i){
      vc.classList.remove('show');
      setTimeout(function(){
        kicon.innerHTML = KEYS[i].svg; ktitle.textContent = KEYS[i].t; kdesc.textContent = KEYS[i].d;
        vc.classList.add('show');
      }, 180);
      knav.querySelectorAll('button').forEach(function(b){ b.classList.toggle('on', +b.dataset.i === i); });
    };
    var curk = 0; showKey(0);
    var timer = setInterval(function(){ curk = (curk+1) % KEYS.length; showKey(curk); }, 4500);
    knav.querySelectorAll('button').forEach(function(b){
      b.addEventListener('click', function(){ curk = +b.dataset.i; showKey(curk); clearInterval(timer); });
    });
  }

  /* ===== rewind-to-top button (closing section) ===== */
  var rewind = document.getElementById('rewindBtn');
  if (rewind) rewind.addEventListener('click', function(){
    var start = scrollY;
    if (start <= 0) return;
    if (REDUCE) { scrollTo(0, 0); return; }
    var dur = Math.min(1200, 480 + start * 0.16);   // longer pages "rewind" a touch longer
    var t0 = performance.now();
    document.documentElement.classList.add('rewinding');
    (function step(now){
      var p = Math.min(1, (now - t0) / dur);
      var e = 1 - Math.pow(1 - p, 3);                // easeOutCubic — quick rewind, soft landing
      scrollTo(0, Math.round(start * (1 - e)));
      if (p < 1) { requestAnimationFrame(step); }
      else { document.documentElement.classList.remove('rewinding'); }
    })(t0);
  });

  /* ===== WeChat / in-app WebView: force muted inline autoplay ===== */
  function kickVideos(){
    document.querySelectorAll('video[autoplay]').forEach(function(v){
      v.muted = true;                 // autoplay is only allowed when muted
      v.setAttribute('muted','');
      var p = v.play();
      if (p && p.catch) { p.catch(function(){}); }
    });
  }
  kickVideos();
  addEventListener('load', kickVideos);
  // WeChat fires this once its JS bridge is ready — replay then
  document.addEventListener('WeixinJSBridgeReady', kickVideos, false);
  // last resort: first user gesture unlocks playback in strict WebViews
  ['touchstart','click'].forEach(function(ev){
    document.addEventListener(ev, kickVideos, { once:true, passive:true });
  });
})();
